import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-03-29'
        tag='Facebook Marketplace'
        title="Facebook Marketplace Scams: A Seller's Guide to Scam-free transactions."
      >
        <p>
          Online selling platforms are easily accessible to all users. Whether sellers or buyers, each has a place in
          the online business world. Aside from the convenience, the variety of goods is also massive, offering more
          options to everyone. Unfortunately, online shopping has flaws similar to the real world, including scams.{' '}
        </p>
        <p>
          Often, people who complain about scams are buyers. Each has their own story to tell, but they all agree that
          the criminals who deceived them are convincing. It is not surprising that these same fraudsters are also
          targetting sellers as they can gain more from the source.
        </p>
        <p>
          As an online seller, receiving inquiries on your listing is great. It gets you excited most of the time as
          that would mean a new opportunity to make sales. However, while many buyers are really interested in paying
          for your item, not all people posing as your potential buyer have pure intentions. Surely, if you haven't
          experienced it yourself, you have read some reports of sellers who got scammed by a buyer.{' '}
        </p>
        <p>
          Scams could come in many forms. But the common ground of these scams is that they leave the sellers on a
          losing end while the scammers get hold of the items without spending any penny. Whether it is a small amount
          or something that costs a fortune, losing an item you bought to sell still affects your business.{' '}
        </p>
        <p>
          Facebook Marketplace is a melting pot of millions of sellers across the globe. And while it is truly
          beneficial in generating extra income, fraudsters are also present on the platform. Unlike more structured
          online marketplaces like eBay, Poshmark, Mercari, and the likes, potential buyers are freer to directly
          interact with sellers allowing them to scheme their plan and convince sellers with their tricks.
        </p>
        <p>
          As an online seller at risk, you must know how to protect your money and your business from opportunists
          waiting for you to take the bait. Learn here the common scams committed by scammers on Facebook Marketplace so
          you can familiarize yourself with them and avoid them in the future.{' '}
        </p>

        <h3>Types of Scams</h3>
        <ol>
          <li>
            <strong>Damaged item received.</strong> Most scammers would do this. They will buy your item, go through the
            process of paying, and receive the item and then they would suddenly file a dispute that the item they
            received is faulty or has undisclosed damages. Facebook marketplace encourages both parties to settle this
            first, and they will step in if no resolution is decided between the seller and buyer. If you fail to
            counter the buyer's claims and provide proof, the dispute will result in a refund. This will mean that
            you'll lose your item, and the buyer will get her money back.
          </li>
          <li>
            <strong>Item not received.</strong> Another common scam is when buyers claim that they did not receive the
            item when they actually did. They can easily file a dispute about this and get a refund should you fail to
            prove that the item has been delivered and received. You may lose your item and money on this scam like the
            damaged item claim.{' '}
          </li>
          <li>
            <strong>Payment outside the platform.</strong> Some buyers are determined to deceive you and will ask that
            you take the transaction outside the platform. They can pose as nice people and tell you stories to get your
            trust and agree with their wishes. Don't fall for any promises and send off anything without getting paid
            for your item.
          </li>
          <li>
            <strong>Stolen item during the meetup.</strong> Some buyers would ask you to hand them the item and suddenly
            make excuses. This includes going to the bathroom or getting money in the bank or meeting a friend nearby so
            the person can check your item, and they never show up again. This is a common tactic of thieves. While it
            is sad that there are people who do this, it happens in real life. They pose as a nice person and will
            eventually take away your item without paying for it.
          </li>
        </ol>

        <h3>Avoid Getting Scammed</h3>
        <p>
          Being prepared is the best way to protect yourself and your business from getting scammed. Here are some tips
          that sellers like you should take note of.
        </p>
        <ol>
          <li>
            <strong>Secure enough photos and videos of your item before dispatching the package.</strong> Doing so will
            help you counter any dispute these scammers may claim against you so they can get a refund and keep your
            item for free. Ensure to have sufficient evidence if they made up a story about the item you sent them.
          </li>
          <li>
            <strong>Always opt for tracked shipment.</strong> Having the tracking information for your items will help
            you know the status of the package you sent to the buyer. If the buyer claims that they did not receive it,
            you can always counter with the tracking information or the delivery status provided by your shipping
            service.
          </li>
          <li>
            <strong>Always complete the transaction on the platform.</strong> It is best to stick to transact within the
            Facebook marketplace. Always opt to receive payments via secure methods such as PayPal or Facebook Checkout.
          </li>
          <li>
            <strong>Protect your personal information.</strong> Scammers can use your information against you. Giving
            your potential buyer your bank details or sending them your ID so they can settle their order via bank or
            other modes of payment can give them access to your bank accounts or credit card. Also, identity theft is a
            common crime they commit.
          </li>
          <li>
            <strong>Don't trust easily.</strong> Don't fall for ship now; pay later schemes. Not because your buyer
            seems nice to talk to, you will quickly put your trust in them. Remember, all these fraudsters will do
            anything to get your trust.
          </li>
          <li>
            <strong>Don't go on your own.</strong> If you plan to meet a buyer for a local pickup transaction, get the
            person's details before the meetup and bring someone along. This will ensure your safety, and fraudsters
            will think twice about conning you. If bringing someone is not possible, let others know about your upcoming
            transaction and refrain from wearing expensive clothing or jewelry pieces.
          </li>
        </ol>

        <h3>Use the Create Plan Feature!</h3>
        <p>
          This feature is beneficial should you and your buyer decide to do a local pickup transaction. It is always a
          best practice to meet your buyer in public and broad daylight to ensure your safety. In addition to this, you
          should let someone you trust about your transaction and where it will occur.{' '}
        </p>
        <p>
          Good thing that Facebook Marketplace has this feature. You can easily create a meetup plan and send it to your
          buyer and your friends and family for added protection. To create the plan:
        </p>
        <ol>
          <li>Open your Messenger thread with the buyer and tap the More options button.</li>
          <li>Select Create meetup plan </li>
          <li>Choose the method and add the time your meetup is set. This also lets you add the location and notes.</li>
          <li>Share the plan by tapping the Send Plan button.</li>
        </ol>
        <p>To share the plan you've created, you have to:</p>
        <ol>
          <li>Tap on the Send plan button</li>
          <li>Search for the person you want to share the plan with by using the search bar</li>
          <li>Tap the Send button beside the person's name</li>
          <li>Another option is to tap More options in the thread then tap Share plan</li>
        </ol>
        <p>
          <strong>Note:</strong> Meetup plans get removed from the Messenger thread once the meeting time is met.
        </p>
        <p>
          If you suspect that a buyer is up to suspicious activity or is dishonest, don't hesitate to report them to the
          marketplace. You may do this by:
        </p>
        <ol>
          <li>Clicking the Marketplace in the left menu of your News Feed</li>
          <li>Go to Your Account.</li>
          <li>Choose Your Listings.</li>
          <li>Click on the purchased listing of the buyer.</li>
          <li>
            Click the conversation between you and your buyer. You can click on the See More option if you can't find
            it.
          </li>
          <li>Click on the Report Buyer button.</li>
          <li>Follow the on-screen instructions.</li>
        </ol>

        <p>
          Increasing your items’ visibility and exposure also increases your chance of coming across a scammer. But,
          with these tips in mind, you can now avoid them and focus on growing your business. Now that you are armed
          with this information, you can confidently sell on other platforms which will help you gain chances of making
          sales.
        </p>

        <h3>OneShop As Your Assistant</h3>
        <p>
          Manually listing your items across different marketplaces is time-consuming and requires a lot of effort. But
          you don’t need to worry about this when you’re using a cross-posting app that intelligently works.
        </p>
        <p>
          OneShop is your best friend when it comes to cross-posting and automating. Cross-listing to Facebook will be
          available soon but If you also sell on Poshmark, Mercari, Depop, Tradesy, and more, you can easily cross-list
          effortlessly with the help of this app. All you have to do is draft your listing once, link your selling
          account, and cross-list in no time. It also delists automatically once your listing is sold on another
          platform. Convenient, right?{' '}
        </p>
        <p>
          If you are curious how OneShop can help your business grow, visit{' '}
          <a href='https://tools.oneshop.com/'>OneShop</a> or sign up{' '}
          <a href='https://tools.oneshop.com/signup'>here</a> for a 7-day free trial.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
